export const WHITELIST_PAGES = ['welcome', 'account-deletion']

export const isPageWhitelisted = (page?: string | null) => {
  if (!page) return false
  return WHITELIST_PAGES.includes(page)
}
